import type {
  INewHousingProjectListItem,
  IProjectWithDetailsResponse,
} from "./projects.interface";

/** Maps a project-details payload onto the fields shown in the New Housing list. */
export function applyProjectDetailsToListItem(
  details: IProjectWithDetailsResponse,
): Partial<INewHousingProjectListItem> {
  const scheduledOccupancy = details.scheduledOccupancy.map(({ year, units }) => ({
    year,
    units,
  }));
  const years = scheduledOccupancy.map((row) => row.year);
  const totalUnits = scheduledOccupancy.reduce((sum, row) => sum + row.units, 0);

  return {
    name: details.name,
    status: details.status,
    source: details.source,
    reviewStatus: details.reviewStatus,
    matchedProjectId: details.matchedProjectId,
    projectTypeId: details.projectTypeId,
    projectTypeName: details.projectType,
    address: details.address,
    occupancyStart: years.length > 0 ? Math.min(...years) : null,
    occupancyEnd: years.length > 0 ? Math.max(...years) : null,
    totalUnits,
    scheduledOccupancy,
  };
}
